import { getTranslatedText, HeaderTag, MultiTextField } from '@nile/components';
import { Checkbox } from '@superops/ui-design-system';
import React, { useState } from 'react';
import { injectIntl } from 'react-intl';

const NotificationFilterForm = injectIntl((props) => {
  const { intl, template, updateTemplate } = props;

  const [currentDomains, setCurrentDomains] = useState(
    template?.skipDomains || []
  );
  const [currentEmails, setCurrentEmails] = useState(
    template?.skipEmails || []
  );

  const handleToggle = (checked, prop, val) => {
    if (checked) {
      const sanitized = val
        .map((v) => (typeof v === 'string' ? v.trim() : v))
        .filter(Boolean);
      updateTemplate({ [prop]: sanitized.length > 0 ? sanitized : null });
    } else {
      updateTemplate({ [prop]: null });
    }
  };

  const handleUpdate = (value, prop) => {
    handleToggle(true, prop, value);
  };

  return (
    <>
      <HeaderTag
        title={getTranslatedText(intl, 'admin.emailNotification.skip.title')}
        isBgStrip
        isNewLayout
      />
      <div>
        <Checkbox
          checked={!!template?.skipInitiatedByTechnician}
          label={getTranslatedText(
            intl,
            'admin.emailNotification.skip.initiaterAccountType'
          )}
          onChange={(value) =>
            updateTemplate({ skipInitiatedByTechnician: value })
          }
        />
      </div>
      <div>
        <Checkbox
          checked={!!template?.skipDomains}
          label={getTranslatedText(
            intl,
            'admin.emailNotification.skip.domains'
          )}
          onChange={(value) =>
            handleToggle(value, 'skipDomains', currentDomains)
          }
        />
        <div className="mlr-30">
          <MultiTextField
            onItemAdded={(item, allItems) => {
              setCurrentDomains(allItems);
              handleUpdate(allItems, 'skipDomains');
            }}
            onItemDeleted={(item, allItems) => {
              setCurrentDomains(allItems);
              handleUpdate(allItems, 'skipDomains');
            }}
            name="item-input"
            values={template?.skipDomains}
            placeholder={getTranslatedText(
              intl,
              'admin.emailNotification.skip.domains.pl'
            )}
            // addHelper
          />
        </div>
      </div>
      <div>
        <Checkbox
          checked={!!template?.skipEmails}
          label={getTranslatedText(intl, 'admin.emailNotification.skip.emails')}
          onChange={(value) => handleToggle(value, 'skipEmails', currentEmails)}
        />
        <div className="mlr-30">
          <MultiTextField
            onItemAdded={(item, allItems) => {
              setCurrentEmails(allItems);
              handleUpdate(allItems, 'skipEmails');
            }}
            onItemDeleted={(item, allItems) => {
              setCurrentEmails(allItems);
              handleUpdate(allItems, 'skipEmails');
            }}
            name="item-input"
            values={template?.skipEmails}
            placeholder={getTranslatedText(
              intl,
              'admin.emailNotification.skip.emails.pl'
            )}
            handleValidation={(item) => {
              const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              return !!item.match(regex);
            }}
            // addHelper
          />
        </div>
      </div>
    </>
  );
});

export default NotificationFilterForm;
